<template>
  <div>
    <b-dropdown id="other-options" toggle-tag="div" toggle-class="p-0 bg-transparent border-0">
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('global.object.other')"
          :disabled="isLoading"
        />
      </template>

      <b-dropdown-item @click="handleShowModal">
        {{ $t('delivery.historyDelivery') }}
      </b-dropdown-item>
      <b-dropdown-item v-if="status != 'Draf'" @click="handlePrintPDF">
        {{ $t('delivery.printOrder') }}
      </b-dropdown-item>
    </b-dropdown>

    <McEventList
      :value.sync="modal"
      :data="groupedDoHistories"
      :keys="groupedDoHistoryKeys"
      :title="$t('delivery.historyDelivery')"
      @itemClick="handleShowDetailHistory"
    />

    <DeliveryLoadHistoryDetail :data="selectedHistory" />
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import McEventList from '@/components/McEventList'
import DeliveryLoadHistoryDetail from './DeliveryLoadHistoryDetail'
import * as DoHistory from '@/services/rest-api/lib/delivery/history'
import { MixPanel } from '@/mixin/mixpanel'

import moment from 'moment'
moment.locale('id')

export default {
  components: {
    McButton,
    McEventList,
    DeliveryLoadHistoryDetail,
  },
  mixins: [MixPanel],
  props: {
    status: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getDoHistory: DoHistory.get(this.$route.params.id),
      groupedDoHistories: [],
      groupedDoHistoryKeys: [],
      modal: false,
      selectedHistory: {},
    }
  },
  methods: {
    async handleShowModal() {
      this.track('Open Change Log Delivery')
      this.modal = true

      const queryParam = {
        status: 'status',
      }

      const { data } = await this.getDoHistory(queryParam)
      if (!data) return
      const doHistory = data

      this.groupedDoHistories = []
      this.groupedDoHistoryKeys = []

      let oneDayObject = {}
      let currentDate = moment().startOf('day')
      let currentTimeText = ''

      doHistory.forEach((item, index) => {
        if (item.properties) {
          item.properties.forEach((prop) => {
            if (prop.key === 'No. Penugasan') {
              prop.isRedirectable = false
              prop.redirectUrl = null
            }
          })
        }

        if (item.title.toLowerCase().includes('perubahan kuantitas muatan'.toLowerCase())) {
          item.clickable = true
          item.clickableTitle = 'Lihat Perubahan'
          const typeMatch = item.title.match(/\(([^)]+)\)/)
          item.type = typeMatch ? typeMatch[1] : ''
          item.index = index
          if (item.description.toLowerCase().includes('kuantitas aktual do-'.toLowerCase())) {
            item.do_number = item.description.match(/DO-\d+/i)?.[0] || ''
          }

          for (let i = 0; i < item.properties.length; i++) {
            if (item.properties[i].key === 'delivery_load_log_uuid') {
              item.delivery_order_uuid = 'xxx'
              item.properties.splice(i, 1)
              break
            }
          }

          item.filter = {
            type: item.type,
            updated_by: item.properties.find((prop) => prop.key === 'Diubah oleh')?.value || '',
            created_on: item.created_on,
          }
        }

        const createdOnItem = moment(item.created_on).startOf('day')
        const timeDiff = createdOnItem.diff(currentDate, 'days')

        if (timeDiff === 0) {
          if (index !== 0) oneDayObject[currentTimeText].push(item)
          else {
            currentTimeText = 'Hari Ini'
            oneDayObject[currentTimeText] = []
            oneDayObject[currentTimeText].push(item)
          }
        } else {
          if (index !== 0) {
            this.groupedDoHistories.push({ [currentTimeText]: oneDayObject[currentTimeText] })
            this.groupedDoHistoryKeys.push(currentTimeText)
          }

          currentDate = createdOnItem
          currentTimeText = createdOnItem.format('DD MMM YYYY')

          oneDayObject[currentTimeText] = []
          oneDayObject[currentTimeText].push(item)
        }

        if (doHistory.length - 1 === index) {
          this.groupedDoHistories.push({ [currentTimeText]: oneDayObject[currentTimeText] })
          this.groupedDoHistoryKeys.push(currentTimeText)
        }
      })
    },
    async handlePrintPDF() {
      this.track('Open Dokumen Surat Jalan')
      window.open(
        process.env.VUE_APP_API_ORDER_URL + `/delivery-order/${this.$route.params.id}/pdf`
      )
    },
    handleShowDetailHistory(item) {
      if (item.title.toLowerCase().includes('perubahan kuantitas muatan'.toLowerCase())) {
        this.selectedHistory = item
        this.$nextTick(() => {
          this.$bvModal.show(`mc-modal-load-history-${item.index}`)
        })
      }
    },
  },
}
</script>
